import { render, staticRenderFns } from "./ExInformation.vue?vue&type=template&id=379b4088&scoped=true&"
import script from "./ExInformation.vue?vue&type=script&lang=ts&"
export * from "./ExInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ExInformation.vue?vue&type=style&index=0&id=379b4088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b4088",
  null
  
)

export default component.exports